module.exports = __webpack_public_path__ + "assets/img/14.6fe617a5.png";